import { useStore } from "vuex";

// Восстановление ранее выбранного месяца из localStorage при загрузке страницы и навигации
export function useSavedMonth() {
  const store = useStore();

  const getSavedMonth = () => {
    if (store.getters["getSavedMonthApplied"]) return;

    if (localStorage.getItem("activeNextMonth")) {
      store.commit("setMoth", 1);
      store.commit("setDate", store.getters["getCurrentDate"]);
    } else if (localStorage.getItem("activePrevMonth")) {
      store.commit("setMoth", -1);
      store.commit("setDate", store.getters["getCurrentDate"]);
    }

    store.commit("setSavedMonthApplied", true);
  };

  return { getSavedMonth };
}
